export class DeviceCapability {
  static OnOff = 'onoff';
  static Toggle = 'toggle';
  static Dim = 'dim';
  static Slider = 'slider';
  static LightHue = 'light_hue';
  static LightSaturation = 'light_saturation';
  static LightTemperature = 'light_temperature';
  static LightMode = 'light_mode';
  static VacuumCleanerState = 'vacuumcleaner_state';
  static ThermostatMode = 'thermostat_mode';
  static TargetTemperature = 'target_temperature';
  static MeasureTemperature = 'measure_temperature';
  static MeasureCo = 'measure_co';
  static MeasureCo2 = 'measure_co2';
  static MeasureSo2 = 'measure_so2';
  static MeasurePm25 = 'measure_pm25';
  static MeasureHumidity = 'measure_humidity';
  static MeasurePressure = 'measure_pressure';
  static MeasureNoise = 'measure_noise';
  static MeasureRain = 'measure_rain';
  static MeasureRainIntensity = 'measure_rain_intensity';
  static MeasureWindStrength = 'measure_wind_strength';
  static MeasureWindAngle = 'measure_wind_angle';
  static MeasureGustStrength = 'measure_gust_strength';
  static MeasureGustAngle = 'measure_gust_angle';
  static MeasureBattery = 'measure_battery';
  static MeasurePower = 'measure_power';
  static MeasureVoltage = 'measure_voltage';
  static MeasureCurrent = 'measure_current';
  static MeasureLuminance = 'measure_luminance';
  static MeasureUltraviolet = 'measure_ultraviolet';
  static MeasureWater = 'measure_water';
  static MeasureCarbonFilter = 'measure_carbon_filter';
  static MeasureCh2o = 'measure_ch2o';
  static MeasureContentVolume = 'measure_content_volume';
  static MeasureDistance = 'measure_distance';
  static MeasureHepaFilter = 'measure_hepa_filter';
  static MeasureMoisture = 'measure_moisture';
  static MeasureNox = 'measure_nox';
  static MeasureO3 = 'measure_o3';
  static MeasurePh = 'measure_ph';
  static MeasurePm1 = 'measure_pm1';
  static MeasurePm01 = 'measure_pm01';
  static MeasurePm10 = 'measure_pm10';
  static MeasureRadon = 'measure_radon';
  static MeasureSpeed = 'measure_speed';
  static MeasureTvoc = 'measure_tvoc';
  static MeasureTvocIndex = 'measure_tvoc_index';
  static MeasureWeight = 'measure_weight';
  static MeterPower = 'meter_power';
  static MeterPowerImported = 'meter_power.imported';
  static MeterPowerExported = 'meter_power.exported';
  static MeterWater = 'meter_water';
  static MeterGas = 'meter_gas';
  static MeterRain = 'meter_rain';
  static MeasureAqi = 'measure_aqi';
  static AlarmGeneric = 'alarm_generic';
  static AlarmLight = 'alarm_light';
  static AlarmMotion = 'alarm_motion';
  static AlarmContact = 'alarm_contact';
  static AlarmCo = 'alarm_co';
  static AlarmCo2 = 'alarm_co2';
  static AlarmPm25 = 'alarm_pm25';
  static AlarmTamper = 'alarm_tamper';
  static AlarmSmoke = 'alarm_smoke';
  static AlarmFire = 'alarm_fire';
  static AlarmHeat = 'alarm_heat';
  static AlarmWater = 'alarm_water';
  static AlarmBattery = 'alarm_battery';
  static AlarmNight = 'alarm_night';
  static AlarmBinFull = 'alarm_bin_full';
  static AlarmBinMissing = 'alarm_bin_missing';
  static AlarmCleaningPadMissing = 'alarm_cleaning_pad_missing';
  static AlarmCold = 'alarm_cold';
  static AlarmConnectivity = 'alarm_connectivity';
  static AlarmDoorFault = 'alarm_door_fault';
  static AlarmGas = 'alarm_gas';
  static AlarmLost = 'alarm_lost';
  static AlarmMoisture = 'alarm_moisture';
  static AlarmNoise = 'alarm_noise';
  static AlarmOccupancy = 'alarm_occupancy';
  static AlarmPm01 = 'alarm_pm01';
  static AlarmPm1 = 'alarm_pm1';
  static AlarmPm10 = 'alarm_pm10';
  static AlarmPower = 'alarm_power';
  static AlarmPresence = 'alarm_presence';
  static AlarmProblem = 'alarm_problem';
  static AlarmPumpDevice = 'alarm_pump_device';
  static AlarmPumpSupply = 'alarm_pump_supply';
  static AlarmRunning = 'alarm_running';
  static AlarmSafety = 'alarm_safety';
  static AlarmStuck = 'alarm_stuck';
  static AlarmTankEmpty = 'alarm_tank_empty';
  static AlarmTankMissing = 'alarm_tank_missing';
  static AlarmTankOpen = 'alarm_tank_open';
  static AlarmVibration = 'alarm_vibration';
  static AudioOutput = 'audio_output';
  static BatteryChargingState = 'battery_charging_state';
  static Button = 'button';
  static ChannelDown = 'channel_down';
  static ChannelUp = 'channel_up';
  static DishwasherProgram = 'dishwasher_program';
  static Docked = 'docked';
  static FanMode = 'fan_mode';
  static FanSpeed = 'fan_speed';
  static GarageDoorClosed = 'garagedoor_closed';
  static HeaterOperationMode = 'heater_operation_mode';
  static HomeAlarmState = 'homealarm_state';
  static HotWaterMode = 'hot_water_mode';
  static LaundryWasherCycles = 'laundry_washer_cycles';
  static LaundryWasherProgram = 'laundry_washer_program';
  static LaundryWasherSpeed = 'laundry_washer_speed';
  static LevelAqi = 'level_aqi';
  static LevelCarbonFilter = 'level_carbon_filter';
  static LevelCh2o = 'level_ch2o';
  static LevelCo = 'level_co';
  static LevelCo2 = 'level_co2';
  static LevelHepaFilter = 'level_hepa_filter';
  static LevelNox = 'level_nox';
  static LevelO3 = 'level_o3';
  static LevelPm01 = 'level_pm01';
  static LevelPm1 = 'level_pm1';
  static LevelPm10 = 'level_pm10';
  static LevelPm25 = 'level_pm25';
  static LevelRadon = 'level_radon';
  static LevelSo2 = 'level_so2';
  static LevelTvoc = 'level_tvoc';
  static LockMode = 'lock_mode';
  static Locked = 'locked';
  static MediaInput = 'media_input';
  static MowerState = 'mower_state';
  static OperationalState = 'operational_state';
  static Oscillating = 'oscillating';
  static PumpMode = 'pump_mode';
  static PumpSetpoint = 'pump_setpoint';
  static RefrigeratorMode = 'refrigerator_mode';
  static SpeakerNext = 'speaker_next';
  static SpeakerPlaying = 'speaker_playing';
  static SpeakerPrev = 'speaker_prev';
  static SpeakerRepeat = 'speaker_repeat';
  static SpeakerShuffle = 'speaker_shuffle';
  static SpeakerStop = 'speaker_stop';
  static SpeakerPosition = 'speaker_position';
  static SpeakerDuration = 'speaker_duration';
  static SpeakerArtist = 'speaker_artist';
  static SpeakerAlbum = 'speaker_album';
  static SpeakerTrack = 'speaker_track';
  static SwingMode = 'swing_mode';
  static TargetHumidity = 'target_humidity';
  static TargetHumidityMax = 'target_humidity_max';
  static TargetHumidityMin = 'target_humidity_min';
  static TargetTemperatureLevel = 'target_temperature_level';
  static TargetTemperatureMax = 'target_temperature_max';
  static TargetTemperatureMin = 'target_temperature_min';
  static VacuumCleanerJobMode = 'vacuumcleaner_job_mode';
  static ValvePosition = 'valve_position';
  static VolumeSet = 'volume_set';
  static VolumeUp = 'volume_up';
  static VolumeDown = 'volume_down';
  static VolumeMute = 'volume_mute';
  static WindowCoveringsClosed = 'windowcoverings_closed';
  static WindowCoveringsSet = 'windowcoverings_set';
  static WindowCoveringsState = 'windowcoverings_state';
  static WindowCoveringsTiltDown = 'windowcoverings_tilt_down';
  static WindowCoveringsTiltSet = 'windowcoverings_tilt_set';
  static WindowCoveringsTiltUp = 'windowcoverings_tilt_up';

  static EvChargingState = 'ev_charging_state';
  static EvChargerChargingState = 'evcharger_charging_state';

  // Extra capabilities for Insights
  static EnergyPower = 'energy_power';
  static AccumulatedCost = 'accumulatedCost';
}
